module.exports = __webpack_public_path__ + "img/ali.f62b9b35.jpg";